import { ResponsiveTableRow, Separator, H4 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'

export default function OwsProxyHeirList({ proxyHeirList }) {
  const { t } = useTranslation()
  if (!proxyHeirList || proxyHeirList.length === 0) {
    return null
  }
  return (
    <>
      <H4 size="H5" supplementary>
        {t('ows.proxyHeirList.proxyHeirs', 'Proxy Heirs')}
      </H4>
      <DmcResponsiveTable
        atSizeColumns={{
          default: { labels: [t('name', 'Name'), t('type', 'Type'), t('relationship.label', 'Relationship')] },
        }}
        totalColumnCount={3}
      >
        {proxyHeirList.map((proxyHeir) => {
          return (
            <ResponsiveTableRow
              key={proxyHeir.pid}
              column1={proxyHeir.name}
              column2={proxyHeir.type}
              column3={proxyHeir.relationship}
            />
          )
        })}
      </DmcResponsiveTable>
      <Separator />
    </>
  )
}
